// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".option-text[data-v-2a799eb5]{margin-left:8px}.right-side[data-v-2a799eb5]{margin-left:auto}.form-input-radios[data-v-2a799eb5]{-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
